/**
 * @fileoverview Sentry error tracking configuration and initialization.
 * This module sets up Sentry for error monitoring and session replay in the application.
 */

import * as Sentry from "@sentry/browser";
import {reactAppEnvironment} from "../config";

/**
 * Initializes Sentry error tracking if the DSN is configured.
 * Configures session replay with privacy-focused settings that mask text and block media.
 */
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    replaysSessionSampleRate: 0.001,
    replaysOnErrorSampleRate: 1,
    environment: reactAppEnvironment,
    integrations: [
      new Sentry.Replay({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
  });
}
